<template>
  <div class="item-box-content" style="padding-bottom:0px;">
    <div class="title-font-style">
      <span>合同总览</span>
    </div>
    <el-form
      :class="queryParams.signState===1?'':'details-line-height'"
      style="padding:20px 30px 0 30px;"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="合同编号：">{{queryParams.contractCode}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户名称：">
            <span class="approval" @click="toCusName">{{queryParams.cusName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户合同编号：" label-width="98px">
            <el-input
              v-model="queryParams.customerContractCode "
              placeholder="请输入客户合同编号"
              v-if="queryParams.signState===1"
            ></el-input>
            <span v-else>{{queryParams.customerContractCode||'--'}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="合同金额：">{{queryParams.contractTotal | priceFilter}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="已收账款：">{{queryParams.accountPe | priceFilter}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="应收账款：">{{queryParams.accountRe | priceFilter }}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="已到期账款：">{{queryParams.accountAp | priceFilter }}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="未到期账款：">{{queryParams.notAccountAp | priceFilter }}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="合同状态：">
            <span style="color:#60C96D">{{queryParams.signState | signStateFilters}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="签订时间：">{{queryParams.signDate|dateFilterL}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="当前负责人：">{{queryParams.createUser}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="更新时间：">{{queryParams.updateDate|dateFilterL}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="$route.name==='contractEdit'">
        <el-col :span="8">
          <el-form-item label="收货人：">{{orderContractReceive.receiveName}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话：">{{orderContractReceive.receivePhone}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="收货地址："
          >{{orderContractReceive.receiveAddress+orderContractReceive.receiveInfo}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: ['contractOverview'],
  watch: {
    contractOverview: {
      handler(newVal) {
        this.queryParams = JSON.parse(JSON.stringify(this.contractOverview))
        this.orderContractReceive = newVal.orderContractReceive || {}
      },
      deep: true
    }
  },
  data() {
    return {
      queryParams: {},
      orderContractReceive: {}
    }
  },
  methods: {
    toCusName() {
      this.$router.push({ name: 'customer/details', query: { id: this.queryParams.cusId } })
    }
  }
}
</script>
